var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensiveDeviceCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "router-accesspoint-wifi-laptop-computer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466,330c13.2,0,24-10.8,24-24v-48c0-13.2-10.8-24-24-24h-16V34c0-13.3-10.7-24-24-24s-24,10.7-24,24v200H114 V34c0-13.3-10.7-24-24-24S66,20.7,66,34v200H34c-13.2,0-24,10.8-24,24v48c0,13.2,10.8,24,24,24h208v65.4 c-6.8,2.5-12.1,7.8-14.6,14.6H162v-24c0-13.2-10.8-24-24-24H42c-13.2,0-24,10.8-24,24v56c-4.4,0-8,3.6-8,8v16c0,13.2,10.8,24,24,24 h112c13.2,0,24-10.8,24-24v-16c0-4.4-3.6-8-8-8v-16h65.4c4.4,12.5,18,19,30.5,14.7c6.9-2.4,12.3-7.8,14.7-14.7H330v8 c0,13.2,10.8,24,24,24h32v16h-16v16h80v-16h-16v-16h32c13.2,0,24-10.8,24-24v-64c0-13.2-10.8-24-24-24H354c-13.2,0-24,10.8-24,24 v40h-57.4c-2.5-6.8-7.8-12.1-14.6-14.6V330H466z M34,386c0-4.4,3.6-8,8-8h96c4.4,0,8,3.6,8,8v56H34V386z M154,466c0,4.4-3.6,8-8,8 H34c-4.4,0-8-3.6-8-8v-8h128V466z M418,474h-16v-16h16V474z M346,370c0-4.4,3.6-8,8-8h112c4.4,0,8,3.6,8,8v40H346V370z M346,426 h128v8c0,4.4-3.6,8-8,8H354c-4.4,0-8-3.6-8-8V426z M418,34c0-4.4,3.6-8,8-8s8,3.6,8,8v200h-16V34z M82,34c0-4.4,3.6-8,8-8 s8,3.6,8,8v200H82V34z M250,426c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S254.4,426,250,426z M34,314c-4.4,0-8-3.6-8-8v-48 c0-4.4,3.6-8,8-8h432c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210,458h16v16h-16V458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242,458h16v16h-16V458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274,458h16v16h-16V458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,74c29.7-0.1,58.2,11.8,79.1,32.9l11.3-11.3c-49.8-50-130.7-50.1-180.7-0.3c-0.1,0.1-0.2,0.2-0.3,0.3 l11.3,11.3C191.8,85.8,220.3,73.9,250,74L250,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.9,118.1c-37.5-37.5-98.3-37.5-135.8,0l11.3,11.3c31.3-31.2,81.9-31.2,113.2,0L317.9,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.3,140.7c-25-25-65.5-25-90.5,0c0,0,0,0,0,0l11.3,11.3c18.7-18.7,49.1-18.7,67.9,0c0,0,0,0,0,0 L295.3,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,186c0,17.7,14.3,32,32,32s32-14.3,32-32s-14.3-32-32-32S218,168.3,218,186z M266,186c0,8.8-7.2,16-16,16 c-8.8,0-16-7.2-16-16s7.2-16,16-16C258.8,170,266,177.2,266,186z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,274h16v16H42V274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,274h16v16H74V274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,274h16v16h-16V274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442,274h16v16h-16V274z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveDeviceCoverage);
export default __webpack_public_path__ + "static/media/Comprehensive Device Coverage.96c300392b18e91d320c314db0f5302c.svg";
export { ForwardRef as ReactComponent };